import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function TimerBar() {
  const time = useCountdown(14 * 3600 + 53 * 60 + 32);
  return <div className="sticky top-0 z-50 border-b border-lime-700/40 bg-lime-600 text-ink-950" data-id="element-193" data-mp="1uiz3dey27smv">
      <div className="mx-auto flex max-w-content flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2.5 text-center text-[11px] font-bold uppercase tracking-wide sm:text-xs" style={{
      paddingTop: "9px",
      paddingBottom: "0px",
      paddingLeft: "16px",
      paddingRight: "16px"
    }} data-id="element-194" data-mp="1pjm6e1dh556k">
        <span className="inline-flex items-center gap-1.5" data-id="element-195" data-mp="wsug1kj3bar5">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-196" data-mp="1bl5zoafm3eof" />
          50% OFF
        </span>
        <span className="hidden sm:inline" data-id="element-197" data-mp="16s34jxv6rx64">—</span>
        <span className="normal-case font-semibold" data-id="element-198" data-mp="j3aeuj55qljy">
          This price disappears when the timer hits zero
        </span>
        <span className="rounded-full bg-ink-950 px-3 py-1 font-mono text-xs font-bold tabular-nums text-lime-400" aria-live="off" style={{
        width: "133px",
        height: "22px"
      }} data-id="element-199" data-mp="e4z6kcuigj3u">
          {time}
        </span>
      </div>
    </div>;
}